export default "__VITE_ASSET__DJQOC2TY__";